import '.by{position:relative;}.ssr-plugin'
import '.iy{display:inline-block;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import '.iz{padding:0.25rem 1rem;}.ssr-plugin'
import '.b0{border-radius:1.875rem;}.ssr-plugin'
import '.j0{border:2px solid var(--primary-blue);}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.b8{color:var(--primary-blue);}.ssr-plugin'
import '.at{cursor:pointer;}.ssr-plugin'
import '.dn{padding:0.75rem 1.25rem;}.ssr-plugin'
import { styled } from 'inlines'
import { useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import Column from '@app/components/layout/Column'
import { Text } from '../typography/Text'
import useClickOutside from '@app/util/hooks/useClickOutside'

export type SortOption = {
  value: string
  label: string
}

export type SortingDropdownProps = {
  options: SortOption[]
  selectedValue: string
  onSelect: (value: string) => void
}

export const SortingDropdown = ({
  options,
  selectedValue,
  onSelect,
}: SortingDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const selectedOption = options.find((opt) => opt.value === selectedValue)

  useClickOutside(dropdownRef, () => setIsOpen(false))

  const handleSelect = (value: string) => {
    onSelect(value)
    setIsOpen(false)
  }

  return (
    <div className="by iy"
      ref={dropdownRef}
    >
      <styled.button className="i n an iz b0 j0 co b8 at"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          '&:hover': {
            background: 'var(--gray-50)',
          },
        }}
      >
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            fontWeight: 600,
            fontSize: '1rem',
          }}
        >
          {selectedOption?.label}
        </Text.Medium>
        <FontAwesomeIcon
          icon={faChevronDown}
          style={{
            color: 'var(--primary-blue)',
            fontSize: '0.875rem',
          }}
        />
      </styled.button>

      {isOpen && (
        <Column
          alignItems="stretch"
          style={{
            position: 'absolute',
            top: 'calc(100% + 0.5rem)',
            left: 0,
            minWidth: '100%',
            backgroundColor: 'var(--shades-white)',
            borderRadius: '0.75rem',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
            zIndex: 1000,
            overflow: 'hidden',
          }}
        >
          {options.map((option) => (
            <styled.div className="dn at"
              key={option.value}
              onClick={() => handleSelect(option.value)}
              style={{
                backgroundColor:
                  option.value === selectedValue
                    ? 'var(--gray-100)'
                    : 'var(--shades-white)',
                '&:hover': {
                  backgroundColor: 'var(--gray-100)',
                },
              }}
            >
              <Text.Medium
                style={{
                  color: 'var(--primary-blue)',
                  fontSize: '1rem',
                }}
              >
                {option.label}
              </Text.Medium>
            </styled.div>
          ))}
        </Column>
      )}
    </div>
  )
}
